import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Button from '../../components/ui/Button';
import { Beer, Home, HelpCircle } from '../../lib/lucide-proxy';

const NotFound = () => {
  const location = useLocation();

  return (
    <>
      <Helmet>
        <title>Página não encontrada - Cerveja Delivery</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen bg-cream-300 flex items-center justify-center px-4 sm:px-6 lg:px-8 relative overflow-hidden">
        {/* Background Decoration */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute -top-20 -left-20 w-96 h-96 bg-primary-200/30 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-copper-200/30 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-md w-full text-center relative z-10">
          <div className="mb-8 animate-bounce-slow">
            <div className="mx-auto w-24 h-24 bg-white rounded-full shadow-medium flex items-center justify-center">
              <Beer className="w-12 h-12 text-primary-500" />
            </div>
          </div>
          
          <h1 className="font-display font-bold text-8xl text-primary-500 mb-2 tracking-tighter">
            404
          </h1>
          <h2 className="text-2xl font-bold text-dark-900 mb-4">
            Ops! Esse copo está vazio...
          </h2>
          <p className="text-dark-600 mb-8 leading-relaxed">
            Parece que a página <code className="mx-1 px-2 py-1 bg-white rounded border border-gray-200 text-sm text-primary-600 font-mono">
              {location.pathname}
            </code> não existe ou foi movida. Que tal voltarmos para o balcão?
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button variant="primary" size="lg" className="w-full sm:w-auto flex items-center justify-center">
                <Home className="w-4 h-4 mr-2" />
                Voltar ao Início
              </Button>
            </Link>
            <Link to="/contato">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto flex items-center justify-center">
                <HelpCircle className="w-4 h-4 mr-2" />
                Preciso de Ajuda
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;